module.exports = __webpack_public_path__ + "img/scene-trading.e6cf1d2a.jpg";